import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { logDataError } from "../lib/errors";
import { subscribeToPlan } from "../lib/plans";

// Campos de plan del usuario actual (usuarios/{uid}), en tiempo real. undefined mientras carga.
// Varios componentes pueden usarlo a la vez: Firestore comparte una sola escucha del mismo documento.
export function useMyPlan() {
  const { currentUser } = useAuth();
  const [plan, setPlan] = useState(undefined);
  useEffect(() => {
    if (!currentUser) return undefined;
    return subscribeToPlan(currentUser.uid, setPlan, (error) => {
      logDataError(`leer el plan de usuarios/${currentUser.uid}`, error);
      setPlan(null);
    });
  }, [currentUser]);
  return plan;
}
